import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const CloneXrayService = {
    apply: async (payload) => axios.post(API_URL + "/clone_x_ray/apply", payload).then(({ data }) => data).catch((err) => { throw err }),
}

export default CloneXrayService;